import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the MakePositivePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'makePositive',
})
export class MakePositivePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number , ...args) {
     return Math.abs(value); 
  }
}



// WEBPACK FOOTER //
// ./src/pipes/make-positive/make-positive.ts